import { db } from "../firebase/firebase";
import { collection, doc, setDoc, getDoc, getDocs, updateDoc, query, where, serverTimestamp } from "firebase/firestore";


const camposProhibidos = ["codigoMoto", "publishedOnce"];

function limpiarPayload(payload) {
  const limpio = { ...payload };
  camposProhibidos.forEach((key) => delete limpio[key]);
  return limpio;
}

export const getMoto = async (id) => {
  const snap = await getDoc(doc(db, "motos", id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
};

export const updateMoto = async (id, payload) => {
  const limpio = limpiarPayload(payload);
  console.log("Payload limpio que se va a actualizar:", limpio);
  await updateDoc(doc(db, "motos", id), limpio);
  return true;
};

export const listMotosAll = async () => {
  const snap = await getDocs(collection(db, "motos"));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const listMotosBySucursal = async (sucursalId) => {
  const q = query(collection(db, "motos"), where("sucursalId", "==", sucursalId));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const ensureValorRebajadoDefault = (moto) => ({
  ...moto,
  valorRebajado: moto?.valorRebajado == null ? 0 : moto.valorRebajado,
});

// Crea la moto en Firestore (estatus = publicada) y devuelve el id (codigoMoto)
export async function createMotoAndPublish(payload) {
  const id = payload.codigoMoto; // usamos el mismo como ID
  const ref = doc(collection(db, "motos"), id);

  // Defaults coherentes
  const data = {
    ...payload,
    valor: payload.valor ?? null,
    valorRebajado: payload.valorRebajado ?? 0,
    estatus: "publicada",
    categoria: payload.categoria === "Nueva" ? "Nueva" : "Seminueva",
    financiamiento: payload.financiamiento === "Sí" ? "Sí" : "No",
    origen: payload.origen === "Importada" ? "Importada" : "Nacional",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  console.log("🔍 Payload a enviar:", data);

  await setDoc(ref, data, { merge: true });
  return id;
}


